export default __webpack_public_path__ + "static/media/home-page-empty.11500122.svg";